"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsListOptions = void 0;
const react_1 = __importDefault(require("react"));
const renderSub = (item) => {
    var _a;
    return (_a = item.subText) === null || _a === void 0 ? void 0 : _a.map((subText, index) => (react_1.default.createElement(react_1.default.Fragment, null, index > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("br", null),
        subText)) : (subText))));
};
exports.SmlsListOptions = ({ list, style, children }) => {
    return (react_1.default.createElement("ul", { className: "smls-list", style: style },
        list.map((item) => (react_1.default.createElement("li", { key: item.key }, item.readonly ? (react_1.default.createElement("div", { id: item.id, className: "smls-list-range readonly" },
            react_1.default.createElement("div", { key: item.labelId, className: "smls-list-text" },
                react_1.default.createElement("label", { id: item.labelId }, item.label),
                react_1.default.createElement("p", { id: item.labelSubId }, renderSub(item))),
            react_1.default.createElement("i", { className: "material-icons" }, item.type ? item.type : ''))) : (react_1.default.createElement("button", { id: item.id, onClick: item.onClick, type: "button", className: "smls-list-range", disabled: item.disabled },
            react_1.default.createElement("div", { key: item.labelId, className: "smls-list-text" },
                react_1.default.createElement("label", { id: item.labelId }, item.label),
                react_1.default.createElement("p", { id: item.labelSubId }, renderSub(item))),
            react_1.default.createElement("i", { className: "material-icons" }, item.type ? item.type : '')))))),
        children));
};
//# sourceMappingURL=index.js.map